module.exports = __webpack_public_path__ + "static/img/detail-baike.2090ce62.png";